import { UploaderStore } from '@/store/Uploader';

import { IStoreItem, TaskStatus } from '../../type';

// 断点续传的文件状态信息都保存在UploaderStore
// 用来操作store
export class StoreHelper {
  // 更新Store
  static updateStore(workspace: string, fileId: string, info: Partial<IStoreItem>) {
    const { setUploaderInfo, uploaderInfo } = UploaderStore.getState();
    if (!uploaderInfo[workspace]) uploaderInfo[workspace] = {};
    const storeInfo = uploaderInfo[workspace]?.[fileId];
    const { progressData } = info;
    // 已经不存在的任务，如果更新了失败状态就忽略
    if (!storeInfo && progressData?.status === TaskStatus.FAILED) return;
    uploaderInfo[workspace][fileId] = Object.assign(
      {},
      uploaderInfo[workspace]?.[fileId],
      info,
    );

    setUploaderInfo(Object.assign({}, uploaderInfo));
  }

  // 获取Store信息
  static getStoreInfo() {
    return UploaderStore.getState();
  }

  // 设置Store信息
  static setUploaderInfo(info: any) {
    const { setUploaderInfo } = UploaderStore.getState();
    setUploaderInfo(info);
  }
}
